import { memo } from 'react';
import { useAsync } from 'react-use';
import { TeamService } from '@zmedia/bm-soccer-ui/service/TeamService';
import { Element, Section } from '@zmedia/bm-soccer-ui/components';
import { Group } from '@zmedia/bm-soccer-ui/modules/group';
import Empty from '@zmedia/bm-soccer-ui/modules/shared/components/Empty';
import styles from './style.module.scss';

export function TeamMatches(props: any) {
    let data = props.data || {};
    if (!data.sections) {
        const state = useAsync(() => TeamService.getMatches(props.id));
        data = state.value?.data || {};
    }

    if (!data.sections) {
        return (
            <Section>
                <Empty content="Chưa có thông tin lịch thi đấu"></Empty>
            </Section>
        );
    }

    return (
        <Element className={styles['team-matches-section']}>
            <Group groups={data.sections}></Group>
        </Element>
    );
}

export default memo(TeamMatches);
